import type { FC } from 'react'

import { format } from 'date-fns'

import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'
import { getLocalDateTime } from '@/utils/date'
import { classNames } from '@/utils/helpers'

import type { RestrictedWordLog } from '../../types'

interface Props {
  blockedMessageLog: RestrictedWordLog | null
  onClose: () => void
}

export const BlockedMessageDetails: FC<Props> = ({
  blockedMessageLog,
  onClose,
}) => {
  const values = [
    {
      label: 'Creator',
      value: blockedMessageLog?.creatorName,
    },
    {
      label: 'Member',
      value: blockedMessageLog?.senderName,
    },
    {
      label: 'Blacklisted Word',
      value: blockedMessageLog?.restrictedWord,
    },

    {
      label: 'Fan Name',
      value: blockedMessageLog?.fanName,
    },
    {
      label: 'Message',
      value: blockedMessageLog?.message,
    },
    {
      label: 'Date & Time',
      value: blockedMessageLog?.createdAt
        ? format(
            getLocalDateTime(blockedMessageLog?.createdAt),
            'dd/MM/yyyy • hh:mm a',
          )
        : '',
    },
  ]

  return (
    <Dialog show={!!blockedMessageLog}>
      <Dialog.Header>
        <Dialog.Title className="text-center">
          Blocked Messages Log Details
        </Dialog.Title>
      </Dialog.Header>
      <Dialog.Description className="mt-6">
        <div className="flex flex-col pt-6">
          {values.map(({ label, value }, index) => (
            <div
              key={label}
              className={classNames(
                'flex border-b py-3',
                index === values.length - 1 && 'border-none',
              )}
            >
              <span className="text-md min-w-40 flex-shrink-0 font-medium text-secondary-300">
                {label}
              </span>
              <span className="text-md flex-1 font-medium text-secondary-500 dark:text-secondary-100">
                {value}
              </span>
            </div>
          ))}
        </div>
      </Dialog.Description>
      <Dialog.Footer>
        <Button
          onClick={onClose}
          size="sm"
          className="w-full"
          variant="default"
        >
          OK
        </Button>
      </Dialog.Footer>
    </Dialog>
  )
}
